export default __webpack_public_path__ + "static/media/checkMark.800ac7f6.svg";